var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shl-result-empty"},[_vm._v("\n  "+_vm._s(_vm.$tr('interview.landing.modules.shl.reports-empty'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }